import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { sendMetric, openExpertInLinkedin } from '@atheneum/api/dist/lib'
import { toJS } from 'mobx'

import { expertApi } from '@atheneum/api'
import ComplianceButton from '@components/Compliance'
import { StatusLabel } from '@components/StatusLabel'
import InterviewCount from './InterviewCount'
import LastActive from './LastActive'
import LocalTime from '@components/Details/LocalTime'
import Avatar from '@components/Avatar/Avatar'
import Header from '@components/Details/Header'
import HFComplianceStatus from '@components/HFComplianceStatus'
import CopyButton from '@components/CopyButton'
import SherlockReason from '@components/SherlockReason'
import UpdateSvg from '@components/Icon/UpdateSvg'

const CV_UPDATE_THRESHOLD = process.env.CV_UPDATE_THRESHOLD || 14

class ExpertHeader extends Component {
  static propTypes = {
    expert: PropTypes.object,
    expertStore: PropTypes.object,
    commentStore: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object
  }

  complianceSent = () => {
    const { expertStore } = this.props
    expertStore.get(expertStore.id)
  }

  renderLocalTime = () => {
    const timezoneId = this.props.expert.address?.timezoneId
    if (!timezoneId) return

    return <LocalTime timezoneId={timezoneId} />
  }

  buildErrorGrowlProps = type => {
    return {
      title: 'Error!',
      message: `${type} is required.`,
      type: 'error',
      autoClose: true
    }
  }

  updateExpert = async () => {
    const { expert, expertStore } = this.props
    const { growlStore } = expertStore

    let linkedinExpert = expert
    if (!Number(expert.id)) {
      await expertStore.get(expert.id)
      const expertProps = toJS(this.props.expertStore.expert)

      if (!expertProps.email && !expertProps.address.emails.length) {
        growlStore.addNotification(this.buildErrorGrowlProps('Email'))
        return false
      } else if (!expertProps.experiences.length) {
        growlStore.addNotification(this.buildErrorGrowlProps('Experience'))
        return false
      } else if (!expertProps.languages.length) {
        growlStore.addNotification(this.buildErrorGrowlProps('Language'))
        return false
      } else if (!expertProps.title) {
        growlStore.addNotification(this.buildErrorGrowlProps('Title'))
        return false
      } else {
        const createdExpert = await expertApi.create(expertProps)
        linkedinExpert = createdExpert
      }
    }

    await Promise.all([
      openExpertInLinkedin(linkedinExpert, false),
      sendMetric('update_profile.update_button', 'update-profile')
    ])

    if (!Number(expert.id)) {
      this.props.history.replace(
        `${this.props.history.location.pathname.includes('expert-search')
          ? '/expert-search'
          : ''
        }/expert/${linkedinExpert.id}`
      )
    }
  }

  renderUpdateButton = () => {
    const ex = this.props.expert
    let lastUpdated = 'Last update unknown'
    if (ex.cv && ex.cv.updated_at) {
      lastUpdated = `Last updated ${moment(ex.cv.updated_at).format(
        'MMM D, YYYY'
      )}`
    }
    const needsUpdating = !(
      ex.cv &&
      ex.cv.updated_at &&
      moment(ex.cv.updated_at).isAfter(
        moment().subtract(CV_UPDATE_THRESHOLD, 'days')
      )
    )
    return (
      <button onClick={this.updateExpert}>
        <UpdateSvg needsUpdating={needsUpdating} lastUpdated={lastUpdated} />
      </button>
    )
  }

  render() {
    const { expert, expertStore, history, match } = this.props
    if (!expert) return null

    const avatarPath = expert && expert.picture ? expert.picture.path : null
    const urlMatch = match.url.match(/search/)
    const isLinkToFullPage = urlMatch && urlMatch.length > 0

    return (
      <Header>
        <Avatar alt="Expert avatar" src={avatarPath} />
        <div className="info">
          <div>
            <div className="name-status-wrapper expert">
              <h1
                className={`${isLinkToFullPage ? 'title-link' : ''} m-r-sm`}
                onClick={() =>
                  isLinkToFullPage && history.push(`/expert/${expert.id}`)
                }>
                {expert.title} {expert.fullName}
              </h1>
              <div className="copy-wrapper">
                <CopyButton value={expert.fullName} />
              </div>
              <br />
              <h1>
                {expert.originalName}
              </h1>
              <div className="m-b-md" style={{ display: 'flex' }}>
                <StatusLabel
                  statusId={expert.expertStatusId || expertStore.expertStatusId}
                  statusesType="expertStatuses"
                  icon
                />
                <SherlockReason
                  sherlock={expert.sherlock || expertStore.sherlock}
                />
              </div>
            </div>
            <div className="code-and-update">
              <span className="code-label">{expert.expert?.expertCode}</span>
              {this.renderUpdateButton()}
            </div>
            <ComplianceButton
              expert={expert.expert}
              expertStore={expertStore}
              callback={this.complianceSent}
              commentStore={this.props.commentStore}
              history={this.props.history}
              allowComplianceUpdate
              referrer={`expert-search/expert/${expert.id}`}
            />
            {expert.hfCompliances && (
              <HFComplianceStatus
                expert={expert.expert}
                hfCompliances={expert.hfCompliances}
                callback={this.complianceSent}
              />
            )}
          </div>
        </div>

        {this.renderLocalTime()}

        <LastActive value={expertStore.lastActive} label="Last active" />

        <InterviewCount
          labelStyle={{ maxWidth: 90 }}
          interviewCount={expertStore.interviewCount}
          label="Interviews done"
        />
      </Header>
    )
  }
}

export default withRouter(inject('expertStore')(observer(ExpertHeader)))
